export const deleteLocalStorage = (key: string):void => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.info(error);
  }
};

export default deleteLocalStorage;
